import { header, logger } from '@serverless'

const getLargestImage = (image) => {
	const formats = image?.formats ?? image?.data?.attributes?.formats ?? {};
	logger.debug(formats);
	if (formats.large) {
	  return formats.large;
	} else if (formats.medium) {
	  return formats.medium;
	} else if (formats.small) {
	  return formats.small;
	} else if (formats.thumbnail) {
	  return formats.thumbnail;
	} else {
	  return null;
	}
  };

  const getSmallestImage = (image) => {
	const formats = image?.formats ?? image?.data?.attributes?.formats ?? {};
	logger.debug(formats);
	if (formats.thumbnail) {
	  return formats.thumbnail;
	} else if (formats.small) {
	  return formats.small;
	} else if (formats.medium) {
	  return formats.medium;
	} else if (formats.large) {
	  return formats.large;
	} else {
	  return null;
	}
  };

  const getCollectionTypes = async (url, mapFn) => {
	let collections = [];
	let page = 1;
	let hasMore = true;

	do {
	  const response = await fetch(`${url}&pagination[page]=${page}&pagination[pageSize]=10`, {
		method: "GET",
		headers: header,
		mode: "cors",
	  }).then(res => res.json());

	  if (Array.isArray(response.data)) {
		// Apply the mapping function to each result.
		const paths = response.data.map(mapFn);
		collections = collections.concat(paths);
		hasMore = response.meta.pagination.page < response.meta.pagination.pageCount;
	  } else {
		hasMore = false;
	  }
	  page++;
	} while (hasMore);

	return collections;
  };

  export {
	getLargestImage,
	getSmallestImage,
	getCollectionTypes
  };

